module.exports = __webpack_public_path__ + "img/two.225c8806.jpg";